
<div [class.invisible]="!isInitialLayoutCompleted" [ngClass]="{
    'water-fall-container': !modernBlockStyle,
    'flexed-container': modernBlockStyle
}" [class.all-loaded]="isAllItemsLoaded" #container (scroll)="onScroll()">
    <ng-content></ng-content>
</div>
<ig-spinner *ngIf="!isAllItemsLoaded && isScrolledToEnd && isLoadingItems && !isHideSpinner" [diameter]="48"
    [strokeWidth]="4"></ig-spinner>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/water.fall.container/water.fall.container.component.html